let getsec = function (str) {
  if (/[s|h|d|l]/i.test(str)) {
    var str1 = str.substring(0, str.length - 1)
    var str2 = str.substring(str.length - 1, str.length)
    if (str2 === 's') {
      return str1 * 1000
    } else if (str2 === 'h') {
      return str1 * 60 * 60 * 1000
    } else if (str2 === 'd') {
      return str1 * 24 * 60 * 60 * 1000
    }
  } else {
    if (str.indexOf('l') === -1) {
      return str * 1000
    } else {
      return 30 * 24 * 60 * 60 * 1000
    }
  }
}

export let setCookie = function setCookie (name, value, time) {
  if (time) {
    let strsec = getsec(time)
    let exp = new Date()
    exp.setTime(exp.getTime() + parseInt(strsec))
    document.cookie =
      name + '=' + escape(value) + ';expires=' + exp.toGMTString()
  } else {
    document.cookie = name + '=' + escape(value)
  }
}
export let getCookie = function (name) {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  return arr ? unescape(arr[2]) : null
}
export let getToken = function () {
  if (document.cookie) {
    return getCookie('Guest')
  } else if (window.sessionStorage && window.sessionStorage.Guest) {
    return window.sessionStorage.Guest
  } else if (window.localStorage && window.localStorage.Guest) {
    return window.localStorage.Guest
  }
}
export let setToken = function (token) {
  if (document.cookie) {
    setCookie('Guest', token, '365d')
    console.log('cookie', token)
  } else if (window.sessionStorage) {
    window.sessionStorage.Guest = token
    console.log('sessionStorage', token)
  } else if (window.localStorage) {
    window.localStorage.Guest = token
    console.log('localStorage', token)
  }
}

export function validataOS () {
  if (navigator.userAgent.indexOf('Window') > 0) {
    return 'Windows'
  } else if (navigator.userAgent.indexOf('Mac OS X') > 0) {
    return 'Mac'
  } else if (navigator.userAgent.indexOf('Linux') > 0) {
    return 'Linux'
  } else {
    return 'NUll'
  }
}
/*
 * formatMoney(s,type)
 * 功能：金额按千位逗号分隔，负号用括号
 * 参数：s，需要格式化的金额数值.
 * 参数：type,判断格式化后的金额是否需要小数位.
 * 返回：返回格式化后的数值字符串.
 */

export function formatMoney (s, type) {
  var result = s
  if (s < 0) s = 0 - s
  if (/[^0-9.]/.test(s)) return '0.00'
  if (s == null || s === 'null' || s === '') return '0.00'
  if (type > 0) s = new Number(s).toFixed(type) //eslint-disable-line
  s = s.toString().replace(/^(\d*)$/, '$1.')
  s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
  s = s.replace('.', ',')
  var re = /(\d)(\d{3},)/
  while (re.test(s)) s = s.replace(re, '$1,$2')
  s = s.replace(/,(\d\d)$/, '.$1')
  if (type === 0) {
    var a = s.split('.')
    if (a[1] === '00') {
      s = a[0]
    }
  }
  if (result < 0) result = '(' + s + ')'
  else result = s
  return result
}

export function delay (time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time)
  })
}

export function getCoverString (content, type) {
  let str = ''
  if (type === 2) {
    for (let key in content) {
      str += content[key] + '；'
    }
  } else if (type === 32) {
    str = content.map((v) => v[1]).join('-')
  }
  return str
}
export function getCoverJson (content, type) {
  let obj = content
  if (type === 32) {
    let o = {}
    content.map((v) => {
      o = Object.assign({}, o, {
        [v[0]]: v[1]
      })
    })
    obj = o
  }
  return JSON.stringify(obj)
}
